import React, { useEffect, useMemo, useRef, useState } from 'react';
import TableGrid from "../../../../Components/common/TableGrid";
import TableFilters from '../../../../Components/common/TableGrid/TableFilters';
import { useDispatch, useSelector } from 'react-redux';
import { useGetInboundFlightListQuery } from '../../../../redux/services/SPL';
import { CallApi, CommonModal, getTodayDate, getTodayDateTime } from '../../../../Components/common/CommonFunctions';
import { toast } from 'react-toastify';
import { Button, Form, Row, Col } from 'react-bootstrap';
import { faXmark, faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactComponent as Editicon } from "../../../../assets/images/icon_svg/pen_w_line.svg";
import {GETOWNERCODE } from '../../../../Utils/conts';
import Select from "react-select";
import { onTabChange } from '../../../../redux/features/table/tableSlice';

const Flights = () => {
    const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);
    const dispatch = useDispatch();

    const isMounted = useRef(false);
    const [warehouseModal, setWarehouseModal] = useState(false);
    const [warehouseModalData, setWarehouseModalData] = useState(null);
    const [selectedWarehouse, setSelectedWarehouse] = useState('');
    const [warehouseOptions, setWarehouseOptions] = useState([]);
    const [getOwnerCodes, setGetOwnerCode] = useState([]);

    const fetchWarehouse = async () => {
          CallApi({
              endPoint: "warehouse/list",
              method: "post",
              payload: {
                org_station_id: JSON.parse(localStorage.getItem("Handler_stn") || "{}").org_station_id,
                type: "All"
              },
              onSuccess: (res) => {
                  const innerData = res.data.response_data;
                  const transformedData = innerData ? innerData.map(item => ({
                      value: item.id,
                      label: item.name
                  })) : [];
                  setWarehouseOptions(transformedData);
              },
              onError: (msg) => console.error(msg)
          });
      };

    const fetchOwnerCode = async () => {
        CallApi({
            endPoint: GETOWNERCODE,
            method: "post",
            onSuccess: (res) => {
                const innerData = res.data.response_data;
                const transformedData = innerData ? innerData.map(item => ({
                    value: item.IATA,
                    label: item.IATA
                })) : [];
                setGetOwnerCode(transformedData);
            },
            onError: (msg) => console.error(msg)
        });
    };
      useEffect(() => {
          dispatch(onTabChange({ key: 'tab', value: "A" }));
          if (isMounted.current) return;
          fetchWarehouse();
          fetchOwnerCode();
          isMounted.current = true;
      }, [])
  
        const buildFilterParams = (filtersObj) => {
            const params = {};
            Object.entries(filtersObj).forEach(([key, value]) => {
                if (value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0)) {
                    return;
                }
                if (Array.isArray(value)) {
                    params[key] = JSON.stringify(value);
                } else {
                    params[key] = value;
                }
            });
            if (Object.keys(params).length > 0) {
                params.is_filter = true;
            }
            return params;
        };
    
      const queryParams = useMemo(() => {
        const filterParams = buildFilterParams(filters);
        const params = {
          ...filterParams,
          pagenum: pageDetails.pagenum,
          pagesize: pageDetails.pagesize,
        };
        if (sortby?.sortdatafield) {
          params.sortdatafield = sortby.sortdatafield;
          params.sortorder = sortby.sortorder;
        }
        //   if (tab?.value && tab.value !== "all" && tab.key) {
        //       params[tab.key] = tab.value;
        //   }
        return params;
      }, [filters, pageDetails, sortby]);
  
    const { data: myData, isFetching, refetch } = useGetInboundFlightListQuery(queryParams, {
      skip: pageDetails.pagesize === 0,
      refetchOnMountOrArgChange: true,
    });

    const openWarehouseModal = (row) => {
        setWarehouseModalData(row);
        setSelectedWarehouse(row.warehouse?.id || '');
        setWarehouseModal(true);
    };

    const closeWarehouseModal = () => {
        setWarehouseModal(false);
        setWarehouseModalData(null);
        setSelectedWarehouse('');
    };

    const handleSetWarehouse = () => {
    if (!selectedWarehouse) {
        toast.error("Please select a warehouse");
        return;
    }
    CallApi({
        endPoint: `inbound-flights/set-warehouse`,
        method: 'post',
        payload: { 
            flight_id: warehouseModalData.id,  // adjust field name if needed
            warehouse_id: selectedWarehouse 
        },
        onSuccess: (res) => {
            if (res.data.response_code === 200) {
                toast.success(res.data.response_msg);
                closeWarehouseModal();
                refetch();
            } else {
                toast.error(res.data.response_msg);
            }
        },
        onError: (msg) => toast.error(msg)
    });
};

  
    const columns = [
      { label: "Flight No.", field: "flight_no", enableSearch: false, cls: "tw-6" },
      { label: "Flight Date", field: "flight_date", enableSearch: false, cls: "tw-6" },
      { label: "Warehouse", field: "warehouse", enableSearch: false, cls: "tw-6",
            renderCell: (row) => (
                <div>
                    {row.warehouse ? (
                        <>
                            {row.warehouse?.name}
                            <Editicon
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openWarehouseModal(row);
                                }}
                                style={{ cursor: "pointer", marginLeft: "5px" }}
                            />
                        </>
                    ) : (
                        <button className="edit_btn" onClick={(e) => {
                            e.stopPropagation();
                            openWarehouseModal(row);
                        }}>
                            Set Warehouse
                        </button>
                    )}
                </div>
            ),
      },
      { label: "Total AWBs", field: "total_awbs", enableSearch: false, cls: "tw-5", renderCell : (row) => {
          const total_awb = row?.shipments?.length;
          return(total_awb)
      }},
      { label: "Created At", field: "created_at", enableSearch: false, cls: "tw-6", renderCell: (row) => {
          return getTodayDateTime(row?.created_at, "DMY");
          } },
      { label: "Updated At", field: "updated_at", enableSearch: false , renderCell: (row) => {
          return getTodayDateTime(row?.updated_at, "DMY");
          }},
    ];
  
      const filtersConfig = [
      {
        type: "input",
        field: "flight_no",
        placeholder: "Flight No.",
      },
      {
        type: "multiselect",
        field: "flight_prefix",
        placeholder: "Flight Prefix",
        options: getOwnerCodes
      },
      {
        type: "multiselect",
        field: "warehouse_id",
        placeholder: "Warehouse",
        options: warehouseOptions,
      },
    ];

  return (
    <div className="main-content">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <TableFilters filtersConfig={filtersConfig} />
      </div>
      <TableGrid
        columns={columns}
        rows={myData?.Rows}
        totalRecords={myData?.TotalRows || 0}
        onClickRow={(row) => {
          console.log("Clicked Row:", row);
        }}
        checkboxSelection={true}
        loading={isFetching}
        // bulkActions={bulkActions}
        rowKey="id"
      />
       <CommonModal
            show={warehouseModal}
            onHide={closeWarehouseModal}
            title="Set Warehouse"
            subTitle="Update warehouse for flight"
            className="modal_bgw primary_modal"
            footer={
                <div className="d-flex justify-content-between w-100 m-0">
                    <Button variant="secondary" onClick={closeWarehouseModal}>
                        <FontAwesomeIcon icon={faXmark} /> Cancel
                    </Button>
                    <Button variant="primary" onClick={handleSetWarehouse}>
                        <FontAwesomeIcon icon={faSave} /> Set Warehouse
                    </Button>
                </div>
            }
        >
                {/* Shipment Details Card */}
                <div className="resolve_dis primary_bg mb-2">
                    <h6>Flight Details</h6>
                    <Row className="mb-2">
                        <Col sm={6}>
                            <div>
                                <label>Flight No.</label>
                                <p>{warehouseModalData?.flight_no || '-'}</p>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <div>
                                <label>Flight Date</label>
                                 <p>{warehouseModalData?.flight_date
                                    ? getTodayDate(warehouseModalData.flight_date, 'DMY')
                                    : '-'}
                                </p>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <div>
                                <label>Total AWBs</label>
                                <p>{warehouseModalData?.shipments?.length || '-'}</p>
                            </div>
                        </Col>
                    </Row>
                </div>

                {/* Warehouse Dropdown */}
                <Form.Group className="mb-2">
                  <Form.Label>Warehouse <span className="red">*</span></Form.Label>
                  <Select
                      options={warehouseOptions}
                      value={warehouseOptions.find(w => w.value === selectedWarehouse) || null}
                      onChange={(selected) => setSelectedWarehouse(selected?.value || '')}
                      placeholder="Warehouse"
                      isClearable
                      className="w-50"
                  />
              </Form.Group>
            </CommonModal>
    </div>
  );
};

export default Flights;